import {has_ssr} from "@core/helpers/render-type";
import {
	get_all_cookies_server,
	has_cookie_server,
	remove_cookie_server,
	set_cookie_server,
	get_cookie_server
} from "@core/helpers/server/cookie";

import {
	get_all_cookies_client,
	has_cookie_client,
	remove_cookie_client,
	set_cookie_client,
	get_cookie_client,
} from "@core/helpers/client/cookie";


export const get_all_cookies = async () => {
	if (has_ssr()) {
		return await get_all_cookies_server();
	} else {
		return get_all_cookies_client();
	}
}

export const has_cookie = async (name = "") => {
	if (has_ssr()) {
		return await has_cookie_server(name);
	} else {
		return has_cookie_client(name);
	}
}

export const get_cookie = async (name = "") => {
	if (has_ssr()) {
		return await get_cookie_server(name);
	} else {
		return get_cookie_client(name);
	}
}

export const set_cookie = async (name = "", value, options = {}) => {
	if (has_ssr()) {
		return await set_cookie_server(name, value, options);
	} else {
		return set_cookie_client(name, value, options);
	}
}

export const remove_cookie = async (name = "") => {
	if (has_ssr()) {
		return await remove_cookie_server(name);
	} else {
		return remove_cookie_client(name);
	}
}

